import React from 'react';

export default function SelectorInlineOption(props) {

    const onClick = () => {
        !props.item.disabled && props.onClick(props.item.id);
    };

    const classes = Classes('item',{
        selected: props.selected,
        disabled: props.item.disabled
    });

    return (
        <div className={classes} onClick={onClick}>
            {props.item.icon && <div className={Classes('item-icon', props.item.icon)} />}
            <div className="item-label">{props.item.label}</div>
        </div>
    );
}